import { useUserTour } from '@/lib/user-tour';
import { userTourConfigAtom } from '@/states/user-tour.state';
import { useAtom } from 'jotai';

export function useUserTourState() {
  const [userTourConfig] = useAtom(userTourConfigAtom);
  const userTour = useUserTour(userTourConfig);

  return {
    ...userTour,
    config: userTourConfig,
  };
}
